import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType, ISearchProviderField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Profile_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_UI_PROFILE_ID: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WBId', columnResourceName: 'colWBId',         alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    PROFILE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId',             alignment: HorizAlignment.Left}, domainOptions: {}},
    PROFILE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Profile Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SORT_ORDER:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sort', columnResourceName: 'colSort',         alignment: HorizAlignment.Left, numberFormat: "#,##0", columnWidthCharacters: 10}, domainOptions: { maxLength: 50}},
   }

const UIProfileSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_UI_PROFILE_ID',
        id_ui: 'PROFILE_ID',
        name:  'PROFILE_NAME'},

    searchProviderFields: vUI_Profile_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Profile_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}



const UIProfileSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UIProfileSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'PROFILE_ID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'PROFILE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'PROFILE_ID','PROFILE_NAME','SORT_ORDER'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UIProfileSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const UIProfileSearch: ISearch = {
    searchName: "Find Profile",
    renderOptions: { ui5ResourceId: "UIProfileSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UIProfileSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("UIProfileBO", "UIProfile", UIProfileSearch, "Profile Search")

export {UIProfileSearch}
